import { GraphQLError } from 'graphql';
import { graphql } from 'msw';

import { UpdateUserAboutMeMutation } from '../AuthModal/hooks/updateUserAboutMe.generated';

export const generateAboutMeHandler = (
    response: UpdateUserAboutMeMutation['updateUserAboutMe']
) => {
    return graphql.mutation<UpdateUserAboutMeMutation>(
        'updateUserAboutMe',
        (_, res, ctx) => {
            return res(ctx.data({ updateUserAboutMe: response }));
        }
    );
};

export const generateAboutMeErrorHandler = (
    errorMessage: GraphQLError['message']
) => {
    const graphqlError = new GraphQLError(errorMessage);

    return graphql.mutation<UpdateUserAboutMeMutation>(
        'updateUserAboutMe',
        (_, res, ctx) => {
            return res(ctx.errors([graphqlError]));
        }
    );
};

export const defaultAboutMeHandler = generateAboutMeHandler(true);

export const aboutMeFailHandler = generateAboutMeHandler(false);

export const aboutMeServerErrorHandler =
    generateAboutMeErrorHandler('Arbitrary error');
